module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container",
    attrs: {
      "id": "home"
    }
  }, [_c('md-app', {
    attrs: {
      "md-mode": "fixed"
    }
  }, [_c('md-app-toolbar', {
    staticClass: "md-primary"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('md-icon', {
    staticClass: "md-size-2x",
    attrs: {
      "md-src": "/static/img/icons/logo.svg"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("Quick Tourney")]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-section-end"
  }, [(_vm.currentUser) ? _c('div', [_c('md-button', {
    on: {
      "click": _vm.logOut
    }
  }, [_c('span', [_vm._v("Logout")]), _vm._v(" "), _c('md-icon', [_vm._v("person")])], 1)], 1) : _c('div', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.showLoginDialog = true
      }
    }
  }, [_vm._v("Login")])], 1)])], 1), _vm._v(" "), _c('md-app-drawer', {
    attrs: {
      "md-active": _vm.menuVisible
    },
    on: {
      "update:mdActive": function($event) {
        _vm.menuVisible = $event
      }
    }
  }, [_c('MainMenu')], 1), _vm._v(" "), _c('md-app-content', [_c('router-view', {
    attrs: {
      "name": "body"
    }
  })], 1)], 1), _vm._v(" "), _c('md-bottom-bar', {
    attrs: {
      "md-type": "shift",
      "md-sync-route": ""
    }
  }, [(_vm.currentUser) ? _c('md-bottom-bar-item', {
    attrs: {
      "md-label": "Mine",
      "md-icon": "domain",
      "to": "/myTournaments"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-label": "Public",
      "md-icon": "public",
      "to": "/publicTournaments"
    }
  })], 1), _vm._v(" "), _c('md-snackbar', {
    attrs: {
      "md-position": 'center',
      "md-active": _vm.showNotification,
      "md-duration": 5000,
      "md-persistent": ""
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showNotification = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notification))])]), _vm._v(" "), _c('login-dialog', {
    attrs: {
      "show": _vm.showLoginDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showLoginDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45735a00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 446
// module chunks = 1